function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".dots-before_svg__cls-2{fill:#fff}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "dots-before_svg__Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "dots-before_svg__Tryb_izolacji",
  "data-name": "Tryb izolacji"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22.9,
  cy: 3,
  r: 3,
  fill: "#e30613"
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-before_svg__cls-2",
  cx: 15.3,
  cy: 3.2,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-before_svg__cls-2",
  cx: 8,
  cy: 3.2,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-before_svg__cls-2",
  cx: 0.9,
  cy: 3.2,
  r: 0.9
}), /*#__PURE__*/React.createElement("circle", {
  className: "dots-before_svg__cls-2",
  cx: 32.8,
  cy: 3.2,
  r: 0.9
})));

function SvgDotsBefore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.7 6"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMy43IDYiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZTMwNjEzO30uY2xzLTJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+WmFzb8yBYiA0PC90aXRsZT48ZyBpZD0iV2Fyc3R3YV8yIiBkYXRhLW5hbWU9IldhcnN0d2EgMiI+PGcgaWQ9IlRyeWJfaXpvbGFjamkiIGRhdGEtbmFtZT0iVHJ5YiBpem9sYWNqaSI+PGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIyMi45IiBjeT0iMyIgcj0iMyIvPjxjaXJjbGUgY2xhc3M9ImNscy0yIiBjeD0iMTUuMyIgY3k9IjMuMiIgcj0iMC45Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSI4IiBjeT0iMy4yIiByPSIwLjkiLz48Y2lyY2xlIGNsYXNzPSJjbHMtMiIgY3g9IjAuOSIgY3k9IjMuMiIgcj0iMC45Ii8+PGNpcmNsZSBjbGFzcz0iY2xzLTIiIGN4PSIzMi44IiBjeT0iMy4yIiByPSIwLjkiLz48L2c+PC9nPjwvc3ZnPg==";
export { SvgDotsBefore as ReactComponent };